// TelcoTrack - Empty State Component
// Reusable empty state component for displaying when no data is available.
//
// Icon modes (P1 #14 / P2 #18 — "emoji vedle SVG" audit finding):
// - 'default' (default): shared Heroicons inbox SVG from `EMPTY_STATE_ICON_PATH` —
//   used by `app-data-table` and every caller that does not opt into emoji/svg.
// - 'emoji': legacy single-glyph icon via `[icon]` (avoid for new call sites).
// - 'svg': fully custom icon via `<ng-content select="[slot=icon]">`.

import { Component, Input } from '@angular/core';
import { EMPTY_STATE_ICON_PATH } from '../../../utils/empty-state-icon';

@Component({
  selector: 'app-empty-state',
  template: `
    <div class="empty-state text-center py-12">
      <div *ngIf="iconType !== 'emoji' || icon" class="mb-4 flex justify-center">
        <ng-container *ngIf="iconType === 'emoji'">
          <span class="text-6xl">{{ icon }}</span>
        </ng-container>
        <ng-container *ngIf="iconType === 'svg'">
          <ng-content select="[slot=icon]"></ng-content>
        </ng-container>
        <svg
          *ngIf="iconType === 'default'"
          class="w-12 h-12 text-neutral-400 dark:text-neutral-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            [attr.d]="defaultIconPath"
          ></path>
        </svg>
      </div>
      <h3 *ngIf="title" class="text-lg font-medium text-primary mb-2">{{ title }}</h3>
      <p *ngIf="message" class="text-tertiary mt-1">{{ message }}</p>
      <div *ngIf="showAction" class="mt-6">
        <ng-content select="[slot=action]"></ng-content>
      </div>
    </div>
  `,
  styles: []
})
export class EmptyStateComponent {
  readonly defaultIconPath = EMPTY_STATE_ICON_PATH;

  @Input() icon: string = '';
  @Input() iconType: 'emoji' | 'svg' | 'default' = 'default';
  @Input() title: string = 'Žádná data';
  @Input() message: string = '';
  @Input() showAction: boolean = false;
}
